import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import React from "react";
const ArrowsLeftRightIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  const generalColor = APP_CONFIGURATION.colors.general.general_text;
  return __jsx("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("rect", {
    x: "0.25",
    y: "0.25",
    width: "31.5",
    height: "31.5",
    rx: "15.75",
    fill: "white"
  }), __jsx("rect", {
    x: "0.25",
    y: "0.25",
    width: "31.5",
    height: "31.5",
    rx: "15.75",
    stroke: "#B4B4B4",
    strokeWidth: "0.5"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11C8 10.8527 8.0602 10.7114 8.16736 10.6072C8.27451 10.503 8.41985 10.4445 8.57139 10.4445H22.0482L18.4519 6.94946C18.3988 6.89781 18.3566 6.8365 18.3279 6.76902C18.2991 6.70154 18.2843 6.62922 18.2843 6.55618C18.2843 6.48314 18.2991 6.41082 18.3279 6.34334C18.3566 6.27586 18.3988 6.21455 18.4519 6.1629C18.505 6.11125 18.5681 6.07029 18.6375 6.04234C18.7069 6.01439 18.7813 6 18.8564 6C18.9316 6 19.006 6.01439 19.0754 6.04234C19.1448 6.07029 19.2079 6.11125 19.261 6.1629L23.8321 10.6067C23.8853 10.6583 23.9276 10.7196 23.9564 10.7871C23.9852 10.8546 24 10.9269 24 11C24 11.0731 23.9852 11.1454 23.9564 11.2129C23.9276 11.2804 23.8853 11.3417 23.8321 11.3933L19.261 15.8371C19.2079 15.8887 19.1448 15.9297 19.0754 15.9577C19.006 15.9856 18.9316 16 18.8564 16C18.7813 16 18.7069 15.9856 18.6375 15.9577C18.5681 15.9297 18.505 15.8887 18.4519 15.8371C18.3988 15.7855 18.3566 15.7241 18.3279 15.6567C18.2991 15.5892 18.2843 15.5169 18.2843 15.4438C18.2843 15.3708 18.2991 15.2985 18.3279 15.231C18.3566 15.1635 18.3988 15.1022 18.4519 15.0505L22.0482 11.5555H8.57139C8.41985 11.5555 8.27451 11.497 8.16736 11.3928C8.0602 11.2886 8 11.1473 8 11Z",
    fill: generalColor
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 21C24 20.8527 23.9398 20.7114 23.8326 20.6072C23.7255 20.503 23.5802 20.4445 23.4286 20.4445H9.95175L13.5481 16.9495C13.6012 16.8978 13.6434 16.8365 13.6721 16.769C13.7009 16.7015 13.7157 16.6292 13.7157 16.5562C13.7157 16.4831 13.7009 16.4108 13.6721 16.3433C13.6434 16.2759 13.6012 16.2145 13.5481 16.1629C13.495 16.1113 13.4319 16.0703 13.3625 16.0423C13.2931 16.0144 13.2187 16 13.1436 16C13.0684 16 12.994 16.0144 12.9246 16.0423C12.8552 16.0703 12.7921 16.1113 12.739 16.1629L8.16787 20.6067C8.11466 20.6583 8.07244 20.7196 8.04363 20.7871C8.01483 20.8546 8 20.9269 8 21C8 21.0731 8.01483 21.1454 8.04363 21.2129C8.07244 21.2804 8.11466 21.3417 8.16787 21.3933L12.739 25.8371C12.7921 25.8887 12.8552 25.9297 12.9246 25.9577C12.994 25.9856 13.0684 26 13.1436 26C13.2187 26 13.2931 25.9856 13.3625 25.9577C13.4319 25.9297 13.495 25.8887 13.5481 25.8371C13.6012 25.7855 13.6434 25.7241 13.6721 25.6567C13.7009 25.5892 13.7157 25.5169 13.7157 25.4438C13.7157 25.3708 13.7009 25.2985 13.6721 25.231C13.6434 25.1635 13.6012 25.1022 13.5481 25.0505L9.95175 21.5555H23.4286C23.5802 21.5555 23.7255 21.497 23.8326 21.3928C23.9398 21.2886 24 21.1473 24 21Z",
    fill: generalColor
  }));
};
export default ArrowsLeftRightIcon;